const collectSingleTemplateMetaData = (displayName: string) => ({
  title: displayName,
  description: `Customize the pre-made ${displayName} template using Picsart’s editing tools and create your own design.`,
  canonicalURL: window.location.href,
  noIndex: true,
  ogTitle: displayName,
});

export default collectSingleTemplateMetaData;
